import moment from 'moment';
import { RSAA } from 'redux-api-middleware';
import * as A from '../actions/candidateRegistrationActions';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { getDataType } = ssCommonUtils;

export const
toggleModalPasswordResetRequest = () => ({ type: A.TOGGLE_PASSWORD_RESET_MODAL }),
updateCandRegistrationStepStatus = (step, status) => ({ type: A.UPDATE_REGISTRATION_STEP_STATUS, payload: { step, status }}),
clearCandidateRegistrationData = () => ({ type: A.CLEAR_CANDIDATE_REGISTRATION_DATA }),
clearCandidateRegistrationRequest = () => ({ type: A.CLEAR_CANDIDATE_REGISTRATION_REQUEST }),
candidateRegistrationSubmission = (form, captcha) => {
    const
    { candidateEmail, candidatePassport, candidatePersonal, candidateSecurity } = form,
    replaceEmptyStringsInObject = data => {
        switch(getDataType(data)) {
            case 'Object':
                for(let p in data)
                    switch(getDataType(data[p])) {
                        case 'Object': data[p] = replaceEmptyStringsInObject(data[p]); break;
                        case 'String': if(data[p].length === 0) data[p] = null; break;
                    }
                break;
            case 'String':
                if(data.length === 0) data = null; break;
        }
        return data;
    };

    return { [RSAA]: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        endpoint: '/user',
        body: JSON.stringify(replaceEmptyStringsInObject({
            timeStamp: moment.utc().unix(),
            messageUuid: '9dc02909-7597-4faf-a939-788c177d3f3a',
            ssUser: {
                userName: candidateEmail.userId,
                password: '',
                captcha: captcha,
                personalInformation: {
                    firstName: candidatePersonal.firstName,
                    middleName: candidatePersonal.middleName,
                    lastName: candidatePersonal.lastName,
                    nameSuffix: candidatePersonal.nameSuffix,
                    dateOfBirth: candidatePersonal.dob,
                    dateOfBirthType: candidatePersonal.dobType,
                    passportType: candidatePassport.passportType,
                    passportNumber: candidatePassport.passportNumber,
                    expirationDate: candidatePassport.expirationDate,
                    issuingCountry: candidatePassport.issuingCountry,
                    city: candidatePassport.city,
                    email: candidateEmail.emailAddress,
                    phoneNumber: candidatePersonal.phoneNumber,
                    passportIssueDate: candidatePassport.issueDate
                },
                organizationInformation: {
                    fsdo: null,
                    trainingProviderName: null,
                    trainingProviderState: null,
                    trainingProviderType: null,
                    faaCertificationOrSatelliteDesignator: null
                },
                userRoles: [{
                    role: 'CANDIDATE',
                    population: 'AFSP'
                }],
                contactInformation: [{
                    contactValue: candidateEmail.emailAddress,
                    contactType: 'EMAIL'
                }, {
                    contactValue: candidatePersonal.phoneNumber,
                    contactType: 'PHONE_NUMBER'
                }],
                securityQuestions: [{
                    securityQuestionId: 1,
                    securityQuestionAnswer: candidateSecurity.q1
                }, {
                    securityQuestionId: 2,
                    securityQuestionAnswer: candidateSecurity.q2
                }, {
                    securityQuestionId: 3,
                    securityQuestionAnswer: candidateSecurity.q3
                }]
            }
        })),
        types: [
            A.CANDIDATE_REGISTRATION_SUBMISSION_PENDING,
            A.CANDIDATE_REGISTRATION_SUBMISSION_SUCCESS,
            A.CANDIDATE_REGISTRATION_SUBMISSION_FAILURE
        ]
    }}
};
